export default "__VITE_ASSET__DgMXGVPE__"